<template>
  <div class="details">
    <div class="card br-2">
      <div class="p-10">
        <div v-if="countryLanguageDetails">
          <h6 class="fw-bold">COUNTRIES AND LANGUAGES</h6>
          <div class="expand-collapse-container">
            <a href="" class="col-1 p-0 make-link" @click.prevent="expandAll()">Expand all</a>
            <span class="link_style"></span>
            <a href="" class="col-1 p-0 make-link" @click.prevent="collapseAll()">Collapse all</a>
          </div>
          <div class="pt-8" v-for="(singleCountry, index) in countryLanguageDetails" :key="index">
            <div v-b-toggle="'country-id-pdf-' + index">
              <i class="fa fa-plus-circle pr-6 opened"></i>
              <i class="fa fa-minus-circle pr-6 closed"></i>
              <span class="country-name">{{ singleCountry.countryName }}</span>
            </div>
            <b-collapse :id="'country-id-pdf-' + index" v-model="expandCountryLanguageState[index]">
              <div class="card inner-card br-2">
                <div class="pt-10">
                  <b-row>
                    <div class="lang-list">
                      {{ singleCountry.linkedLanguageNames }}
                    </div>
                  </b-row>
                </div>
              </div>
            </b-collapse>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* 
IMPORTANT
Please make sure that this file and country-language-details.vue which is inside the study-details folder are in sync so that the PDF is updated with the most recent code.
 */
export default {
  name: "country-language-details",
  data() {
    return {
      expandCountryLanguageState: []
    };
  },
  components: {},
  props: {
    countryLanguageDetails: {
      type: Array
    }
  },
  methods: {
    expandAll() {
      this.expandCountryLanguageState = this.expandCountryLanguageState.map(() => true);
    },
    collapseAll() {
      this.expandCountryLanguageState = this.expandCountryLanguageState.map(() => false);
    },
    getCountryLanguageState() {
      this.countryLanguageDetails.forEach((element, index) => (this.expandCountryLanguageState[index] = true));
    }
  },
  mounted() {
    this.getCountryLanguageState();
  }
};
</script>

<style scoped>
.link_style {
  border-right: 1px solid #959fa4;
  margin: 0px 5px 0px 2px !important;
}
.country-name {
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.71;
  letter-spacing: normal;
  color: #666669;
}
.inner-card {
  border: none;
  margin: 5px 20px;
  border-radius: 3px !important;
  background-color: #d3dfe4;
}
.lang-list {
  font-size: 13px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 2.31;
  letter-spacing: normal;
  color: #666669;
}
.collapsed > .closed,
:not(.collapsed) > .opened {
  display: none;
}
</style>
